import { ROLE_LIST_START, ROLE_LIST_SUCCESS, ROLE_LIST_FAIL } from './constants';
import { requestGetRoles } from '../../api/role';

export const roleListStart = () => ({ type: ROLE_LIST_START });
export const roleListSuccess = (data) => ({ type: ROLE_LIST_SUCCESS, payload: data });
export const roleListFail = (message) => ({ type: ROLE_LIST_FAIL, payload: message });

export const getListRoles = () => async (dispatch) => {
  try {
    dispatch(roleListStart());
    const data = await requestGetRoles();
    const transformData = data.roles.map(({ id, name }) => ({
      id,
      label: name
    }));
    dispatch(roleListSuccess(transformData));
  } catch (error) {
    dispatch(roleListFail(error.detail));
  }
};
